export default __webpack_public_path__ + "static/media/guitar_active.8a5d16a6.svg";